import {createSlice} from '@reduxjs/toolkit';

const newCellNumberSuccessSlice = createSlice({
  name: 'newCellNumberSuccess',
  initialState: {
    isDisplayPopup: false,
  },

  reducers: {
    reportAnalytics: (state, action) => {},
    showPopup: {
      reducer(state, action) {
        state.isDisplayPopup = action.payload.show;
      },
    },
  },
});

export const {showPopup, reportAnalytics} = newCellNumberSuccessSlice.actions;

export default newCellNumberSuccessSlice.reducer;
